import { createContext, type PropsWithChildren, useContext } from 'react';
import { openWithProtocol } from '@/utils/uri';
import { useAppState } from '@/providers/AppStateProvider';
import { fetchToken } from './utils';

export interface BridgeProviderProps extends PropsWithChildren {}

type BridgeValue = {
  sendFileToBridge: (fileId: number) => Promise<boolean | undefined>;
};

const BridgeContext = createContext<BridgeValue | undefined>(undefined);

export default function BridgeProvider({ children }: BridgeProviderProps) {
  const { onApiError } = useAppState();

  const sendFileToBridge = async (fileId: number) => {
    try {
      // TODO: Can we pass a fileVersionId instead of a fileId? Saves an API call
      const token = await fetchToken(fileId);
      return openWithProtocol(`wm-bridge://open-file?token=${token}`);
    } catch (err) {
      onApiError(err, 'Error opening file');
    }
  };

  const contextValue = {
    sendFileToBridge,
  };

  return (
    <BridgeContext.Provider value={contextValue}>
      {children}
    </BridgeContext.Provider>
  );
}

export function useBridge() {
  const context = useContext(BridgeContext);
  if (!context) {
    throw Error('useBridge must be used within a BridgeProvider');
  }
  return context;
}
